import { devWarn, devError } from './devLog';

export const filteringTableFormatDraftNomination = (draftNominationArray) => {
  if (!draftNominationArray) {
    devWarn('draftNominationArray is undefined or null');
    return [];
  }

  return draftNominationArray
    .map((draftNomination) => {
      if (!draftNomination || !draftNomination.attributes) {
        devWarn('Invalid draftNomination item:', draftNomination);
        return null;
      }

      let draftAttributes;
      try {
        draftAttributes = JSON.parse(draftNomination.attributes.value);

        draftAttributes.value = draftNomination.attributes.value;
        draftAttributes.createdAt = draftNomination.attributes.createdAt;
        draftAttributes.updatedAt = draftNomination.attributes.updatedAt;
        draftAttributes.publishedAt = draftNomination.attributes.publishedAt;
        draftAttributes.nominationStatusTypeId = 1;
        draftAttributes.candidate = `${draftNomination.attributes.name} ${draftNomination.attributes.lastName}`;

        return {
          id: draftNomination.id,
          userId: draftNomination.attributes.userId,
          attributes: draftAttributes,
        };
      } catch (error) {
        devError(
          `Failed to parse and modify JSON for draft nomination with id ${draftNomination?.id}:`,
          error,
        );
        return null;
      }
    })
    .filter(Boolean);
};
